export const ACTION_TYPE_CACHE_SAVE = 'ACTION_TYPE_CACHE_SAVE';
export const actionCacheSave = (key, value) => ({
  type: ACTION_TYPE_CACHE_SAVE,
  payload: {
    key,
    value
  }
});
